const ACCESS_KEY = process.env.VUE_APP_ACCESS_KEY

const url = {
  // company
  company_setting: '/company/v1/public/setting/{access_key}',
  detail_page: `/company/v1/public/detail/${ACCESS_KEY}`,

  // member/users
  user_login: '/auth/v1/member/login',
  user_detail: '/users/v1/member/detail',
  user_auto_login: '/users/v1/member/auto_login_register',
  user_register: '/users/v1/member/auth/register',
  user_update_once: '/users/v1/member/update-profile',
  user_forget_password: '/users/v1/member/forgot-password',
  user_verify_forget_password: '/users/v1/member/verify-forgot-password',
  user_change_forget_password: '/users/v1/member/change-forgot-password',
  user_change_password: '/users/v1/member/change-password',
  
  // question
  question_list: '/bank/v1/question',
  question_detail: '/bank/v1/question/detail/{id}',
  question_detail_public: '/bank/v1/question/public/{id}',

  // storage
  // media_list: '/storage/v1/media',
  // media_detail: '/storage/v1/media/detail/{id}',
  // media_detail_public: '/storage/v1/media/public/{id}',
  media_upload: '/storage/v1/media/user/upload',

  // exam / epot
  exam_index: '/exam/v1',
  exam_list: '/exam/v1/list',
  exam_detail: '/exam/v1/detail/{id}',

  // FORNEXT: Hanya untuk keperluan demo
  get_id: () => 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  }),
  success: (data) => ({
    status: 200,
    message: 'success',
    data,
    validation: {}
  }),
  error: (validation) => ({
    response: {
      data: {
        status: 400,
        message: 'error',
        data: {},
        validation
      }
    }
  }),
}

export default url